// extracted by mini-css-extract-plugin
module.exports = {"rightCol":"AddressesSetup_rightCol__3LeaF"};